import { AuthProviderFactory, getApUserFromIdToken } from "react-ai-platform-auth";

export const {
  AuthProvider,
  Authenticate,
  Authorize,
  useAuthContext,
  withAuthorize,
} = AuthProviderFactory(getApUserFromIdToken);
